package one.healthium.domain.user

import one.healthium.base.preferences.AppPreferences
import one.primehealth.app.UserDataManager

class LogoutInteractor(
    private val userRepository: UserRepository,
    private val userDataManager: UserDataManager,
    private val appPreferences: AppPreferences,
) {
    suspend fun deleteAccount() {
        userRepository.deleteAccount()
        logout()
    }

    suspend fun logout() {
        userRepository.logout()
        userDataManager.clear()
        appPreferences.clearUserPreferences()
    }
}